import { NestedOption } from '~/core/shared/types/utility';

/**
 * The options a select offers once `path` has been chosen above it, or null when the path
 * names an option that does not exist or reaches a leaf, so no further select belongs there.
 */
export const getOptionsAt = (
  options: readonly NestedOption[],
  path: readonly string[],
): readonly NestedOption[] | null => {
  if (path.length === 0) return options;

  const children = options.find((option) => option.value === path[0])?.options;

  if (!children?.length) return null;

  return getOptionsAt(children, path.slice(1));
};
